import { html, css } from 'lit';
import { Styles } from '../types/types';
import LineHeightComponent from './LineHeightComponent';
import WordSpacingComponent from './WordSpacingComponent';
import BgColorComponent from './BgColorComponent';
import HighlightColorComponent from './HighlightColorComponent';
import { accessStore, dispatchUpdate } from '../state/store';
import OlComponent from './OlComponent';
import SpeedReaderComponent from './SpeedReaderComponent';

export default class MoreComponent extends OlComponent {
    update: <K extends keyof Styles>(key: K, value: Styles[K]) => void;

    constructor(update: <K extends keyof Styles>(key: K, value: Styles[K]) => void) {
        super();
        this.update = update;
    }

    // The components that are spawned by the buttons.
    private components = {
        wordSpacing: new WordSpacingComponent((lh: Styles['word-spacing']) => {
            this.update("word-spacing", lh as Styles["word-spacing"])
        }),

        lineSpacing: new LineHeightComponent((lh: Styles['line-height']) => {
            this.update("line-height", lh as Styles["line-height"])
        }),

        bgColor: new BgColorComponent((bgc: Styles["background-color"]) => {
            this.update("background-color", bgc as Styles["background-color"])
        }),

        speedReader: new SpeedReaderComponent(),

        highlightColor: new HighlightColorComponent(),
    }

    // Initialize current component
    private curComponent: {
        id: keyof typeof this.components | null,
        component: OlComponent | null
    } = {
            id: null,
            component: null
        }

    // Change current component
    showComponent = (id: keyof typeof this.components) => {
        dispatchUpdate("moreToolbar", !accessStore("moreToolbar"));
        if (this.curComponent.id == id) {
            this.curComponent = { id: null, component: null }
        } else {
            this.curComponent = { id, component: this.components[id] }
            dispatchUpdate("moreToolbar", true);
        }
    }

    readerUpdate = () => {
        dispatchUpdate("reader", !accessStore("reader"));
    }

    highlightUpdate = () => {
        dispatchUpdate("highlight", !accessStore("highlight"));
    }

    override styles = css`
        @keyframes fadeIn {
            0% {
                opacity: 0;
            }

            70% {
                transform: translateY(calc(90px - 50%)) rotateX(90deg);
            }

            100% {
                opacity: 1;
            }
        }

        .more-container {
            display: flex;
            transform: translateY(calc(90px - 50%)) scale(1);
            background: white;
            box-shadow: 0 0 2px 2px rgba(0,0,0, .2);
            border-radius: 25px;
            padding: 3px;
            flex-wrap: wrap;
            z-index: 101;
            animation: .3s ease-in 0s 1 fadeIn;
        }
        .even-more {
            position: absolute;
            flex: 1;
            bottom: 0;
            transform: translateY(calc(3px + 100%));
            background-color: white;
            box-shadow: 0 0 2px 2px rgba(0,0,0, .2);
            border-radius: 25px;
            flex-direction: column;
            z-index: -1;
            padding: 3px;
        }
    `


    override render() {
        return (
            html`
            <style>${this.styles}</style>
            <div class="more-container">
                <div class="even-more" style="${!this.curComponent.component ? "display: none" : "display:block"}">${this.curComponent.component?.render()}</div>
                <div id="more-component" class="container">
                    <button @click=${() => this.showComponent('lineSpacing')} part="button">
                        <span class="material-icons">format_line_spacing</span>
                    </button>
                    <button @click=${() => this.showComponent('wordSpacing')} part="button">
                        <span class="material-icons">space_bar</span>
                    </button>
                    <button @click=${() => this.showComponent('bgColor')} part="button">
                        <span class="material-icons">format_color_fill</span>
                    </button>
                    <button style="background:${accessStore("reader") ? "#0000FF44" : "inherit"}" @click=${() => this.showComponent('speedReader')} part="button">
                        <span class="material-icons">auto_stories</span>
                    </button>
                    <button @click=${() => this.showComponent('highlightColor')} part="button">
                        <span class="material-icons">colorize</span>
                    </button>
                    <button style="background:${accessStore("highlight") ? "#0000FF44" : "inherit"}" @click=${() => this.highlightUpdate()} part="button">
                        <span class="material-icons">highlight</span>
                    </button>
                </div>
            </div>`
        )
    }
}